import { render, staticRenderFns } from "./settings-organization-payment.vue?vue&type=template&id=3ec63f3e&scoped=true&"
import script from "./settings-organization-payment.vue?vue&type=script&lang=js&"
export * from "./settings-organization-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec63f3e",
  null
  
)

export default component.exports